import './breadcrumb.component.scss';

import { memo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Breadcrumbs = props => {
  const { pathList, children } = props;
  const { t } = useTranslation();

  const createPath = () => {
    return pathList.map((path, index) => {
      return (
        <div key={index} className="child">
          {!path.isLink && <div className="text">{t(path.label)}</div>}
          {path.isLink && (
            <Link className="link" to={path.path}>
              {t(path.label)}
            </Link>
          )}
          {index !== pathList.length - 1 && <div className="divided">/</div>}
        </div>
      );
    });
  };

  return (
    <>
      <div className="breadcrumbs-container">
        <div className="breadcrumbs layout-container">
          <div className="content">
            {pathList && createPath()}
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(Breadcrumbs);
